import { defineExperiment } from '@cian/experiments/ab';
import { DESKTOP_REDESIGN_RECOMMENDATIONS_EXPERIMENT, NEW_MAIN_PAGE_EXPERIMENT } from './experiments';

export const BxMobileBx687NewMainpageExperiment = defineExperiment(NEW_MAIN_PAGE_EXPERIMENT, {
  default: 'A',
  groups: ['A', 'B'] as const,
});

export const BxDesktopBx1106RedesignRecsExperiment = defineExperiment(DESKTOP_REDESIGN_RECOMMENDATIONS_EXPERIMENT, {
  default: 'A',
  groups: ['A', 'B'] as const,
});
